import { connect } from 'react-redux'
import { getLogin, getLoginError } from '../selectors'
import { login } from '../actions'
import Login from '../components/login'

const mapStateToProps = state => ({
  form: getLogin(state),
  error: getLoginError(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  login: formData => dispatch(login(formData, ownProps.history)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login)



// WEBPACK FOOTER //
// ./src/modules/admin/containers/login.js